import api from './AxiosInstance';

export class SuspensionsService {
 
  getSuspensions = async (selectedYear) => {
    try {
      const response = await api.get(`/Participant/SuspensionConso/List/${selectedYear}`, {
     
      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
      // Gérer l'erreur ici si nécessaire
      throw error; 
    }
  };

  getSuspensionsOpt = async () => {
    try {
      const response = await api.get(`/Participant/SuspensionOptiques/List`, {
     
      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
      // Gérer l'erreur ici si nécessaire
      throw error; 
    }
  };
  getSuspensionsAccouchements = async (selectedYear) => {
    try {
      const response = await api.get(`Participant/SuspensionConso08/List/${selectedYear}`, {
     
      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
      // Gérer l'erreur ici si nécessaire
      throw error; 
    }
  };
  getSuspensionsHospis = async (selectedYear) => {
    try {
      const response = await api.get(`Participant/SuspensionConso03/List/${selectedYear}`, {
     
      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
      // Gérer l'erreur ici si nécessaire
      throw error; 
    }
  };
 
}


